import get from 'lodash/get';
import { useMutation } from '@apollo/react-hooks';
import submissionCreate from '../../apollo/mutations/submissionCreate.graphql';
import handleGraphQLMutationErrors from '../../helpers/handleGraphQLMutationErrors';
import submissionUpdate from '../../apollo/mutations/submissionUpdate.graphql';
import { useLanguage } from '../../utils/language';

const useSubmission = ({
  submission,
  classId,
  contentId,
  assignmentType,
  mloId,
  instructionalPlanId,
  onAssignmentLocked,
  onLessonLocked,
} = {}) => {
  const { langCode } = useLanguage();

  const handleMutationError = error => {
    const errorCode = get(error, 'graphQLErrors[0].extensions.code');
    if (onAssignmentLocked && errorCode === 'ASSIGNMENT_LOCKED') {
      onAssignmentLocked({
        code: errorCode,
        message: get(error, 'graphQLErrors[0].message'),
      });
    } else if (onLessonLocked && errorCode === 'LESSON_LOCKED') {
      onLessonLocked({
        code: errorCode,
        message: get(error, 'graphQLErrors[0].message'),
      });
    } else {
      handleGraphQLMutationErrors(error, 'NetworkError', langCode);
    }
  };
  const [submissionCreateMutation] = useMutation(submissionCreate, {
    onError: handleMutationError,
  });
  const [submissionUpdateMutation] = useMutation(submissionUpdate, {
    onError: handleMutationError,
  });

  const saveOrSubmitSubmission = async (input, operation, onSaveOrSubmit) => {
    const variables = {
      input,
    };

    variables.input.type = assignmentType;
    variables.input.classId = classId;
    variables.input.contentId = contentId;
    variables.input.mloId = mloId;
    variables.input.instructionalPlanId = instructionalPlanId;

    let mutationName = 'submissionCreate';
    let mutation = submissionCreateMutation;
    if (submission !== null && submission.status !== 'RE_REQUESTED') {
      mutationName = 'submissionUpdate';
      mutation = submissionUpdateMutation;
      variables.id = submission.id;
      variables.input.id = submission.id;
    }

    const response = await mutation({ variables });
    if (get(response, `data.${mutationName}.assignmentId`)) {
      const submissionId = get(response, `data.${mutationName}.id`);
      onSaveOrSubmit(operation, submissionId);
    }
  };

  return {
    saveOrSubmitSubmission,
  };
};

export default useSubmission;
